// extracted by mini-css-extract-plugin
module.exports = {"button":"OrderButton_button__3Nfj4"};